import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const InvoiceExceptionReportColumns: GridColumnConfig[] = [
  {
    title: 'Work Order#',
    field: 'workOrderNumber',
    filter: 'text',
    width: '124px',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '180px',
    searchable: true,
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    width: '180px',
    searchable: true,
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    width: '180px',
    searchable: true,
  },
  {
    title: 'Work Order Status',
    field: 'workOrderStatus',
    filter: 'text',
    width: '180px',
    searchable: true,
  },

  // {
  //   title: 'Service Price ($)',
  //   field: 'price',
  //   filter: 'text',
  //   width: '180px',
  //   searchable: true,
  // },
  {
    title: 'Service price ($)',
    field: 'priceNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'invoiceAmount',
  //   filter: 'text',
  //   width: '180px',
  //   searchable: true,
  // },
  {
    title: 'Invoice Amount ($)',
    field: 'invoiceAmountNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  // {
  //   title: 'QBO Invoice Amount ($)',
  //   field: 'qboInvoiceAmount',
  //   filter: 'text',
  //   width: '180px',
  //   searchable: true,
  // },
  // {
  //   title: 'QBO Invoice Amount ($)',
  //   field: 'qboInvoiceAmountNumeric',
  //   // fieldType: 'currency',
  //   filter: 'numeric',
  //   width: '180',
  //   searchable: true,
  //   format: '{0:n2}',
  // },
  {
    title: 'Invoice#',
    field: 'invoiceNo',
    filter: 'text',
    width: '100px',
    searchable: true,
  },
  {
    title: 'Invoice Date',
    field: 'invoiceDate',
    filter: 'text',
    width: '150px',
    searchable: true,
  },
  {
    title: 'Invoice Due Date',
    field: 'invoiceDueDate',
    filter: 'text',
    width: '160px',
    searchable: true,
  },
  {
    title: 'Message',
    field: 'message',
    filter: 'text',
    width: '300px',
    searchable: true,
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Unit Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Options',
    field: 'option',
    filter: 'text',
    width: '140px',
    searchable: true,
    locked: true,
    className: 'k-table-th k-grid-header-sticky',
  },
];
